import React from 'react';

import { Card } from '../card';
import {
  StyledTabHeaderContainer,
  StyledTabHeaderDescription,
  StyledTabHeaderTitle,
} from './styled';
import type { TabHeaderProps } from './types';

export const TabHeader: React.FC<TabHeaderProps> = ({
  title,
  description,
  styleProps,
  className,
  testId,
  ...props
}) => {
  return (
    <Card
      styleProps={{
        background: 'white',
        padding: '30px',
        radius: '10px',
      }}
      className={className}
      testId={testId}
      {...props}
    >
      <StyledTabHeaderContainer $height={styleProps?.height}>
        <StyledTabHeaderTitle $titleColor={styleProps?.titleColor}>{title}</StyledTabHeaderTitle>
        {description && (
          <StyledTabHeaderDescription $descriptionColor={styleProps?.descriptionColor}>
            {description}
          </StyledTabHeaderDescription>
        )}
      </StyledTabHeaderContainer>
    </Card>
  );
};